import { useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { TaskLink, SubtaskLink } from "../../types";

export function useAddTaskLink() {
  const queryClient = useQueryClient();

  return async (
    taskId: string,
    url: string,
    description: string
  ): Promise<TaskLink | null> => {
    const { data, error } = await supabase
      .from("task_links")
      .insert({ task_id: taskId, url, description })
      .select()
      .single();

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useAddTaskLink", taskId },
      });
      toast.error("Failed to add link. Please try again.");
      return null;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return data as TaskLink;
  };
}

export function useAddSubtaskLink() {
  const queryClient = useQueryClient();

  return async (
    subtaskId: string,
    url: string,
    description: string
  ): Promise<SubtaskLink | null> => {
    const { data, error } = await supabase
      .from("subtask_links")
      .insert({ subtask_id: subtaskId, url, description })
      .select()
      .single();

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useAddSubtaskLink", subtaskId },
      });
      toast.error("Failed to add link. Please try again.");
      return null;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return data as SubtaskLink;
  };
}
